// We use this pseudo ID to identify the hypothetical sale loan in the waterfall. Because we want to be
// able to run projections prior to the sale/loan being saved, and because the sale/loan data is going to come back
// from the backend in a list of loans, we need to be able to identify it. This is a somewhat arbitrary value.
export const PROJECTION_PSEUDO_ID = 'hsl_projection';
